export default {
  emptyTab: {
    id: 'artist.profile.tab.empty',
    defaultMessage: 'There are no items in this category.',
  },
};
